/* eslint-disable */
import SearchEvents from "./SearchEvents";
import {AggregationType, SearchResult} from "./SearchResult";
import {AppAction} from "../../root/AppAction";

export type ActiveFacetSet = Record<AggregationType, Set<string>>;

export interface SearchStore {
    userId: string;
    activeQuery?: string;
    result?: SearchResult;
    isSearching: boolean;
    activeFacets: ActiveFacetSet;
    activeTargets: string[];
}

const initialStore: SearchStore = {
    userId: "",
    isSearching: false,
    activeFacets: {
        createdYears: new Set<string>(),
        presenters: new Set<string>(),
        tags: new Set<string>()
   },
    activeTargets: [
        "titleHighlights",
        "descriptionHighlights",
        "presenterHighlights",
        "commentHighlights",
        "sceneHighlights"
    ]
};

export default function video(state: SearchStore = initialStore, action: AppAction) {
    switch (action.type) {
        case SearchEvents.SearchStarted:
            const sameQuery = state.activeQuery === action.query;
            return {
                ...state,
                userId : action.userId,
                activeQuery: action.query,
                activeTargets: action.targets,
                activeFacets: {
                    createdYears: sameQuery ? state.activeFacets.createdYears : new Set<string>(),
                    presenters: sameQuery ? state.activeFacets.presenters : new Set<string>(),
                    tags: sameQuery ? state.activeFacets.tags : new Set<string>()
               },
                isSearching: true
           };

        case SearchEvents.SearchCompleted:
            return {
                ...state,
                isSearching: false,
                result: action.result
           };

        case SearchEvents.UnselectFacet: {
            const currentFacetsOfType = state.activeFacets[action.facetType];

            return {
                ...state,
                activeFacets: {
                    ...state.activeFacets,
                    [action.facetType]: new Set(
                        Array.from(currentFacetsOfType).filter(f => f !== action.facet)
                    )
               }
           };
       }

        case SearchEvents.SelectFacet: {
            const currentFacetsOfType = state.activeFacets[action.facetType];

            return {
                ...state,
                activeFacets: {
                    ...state.activeFacets,
                    [action.facetType]: new Set(
                        Array.from(currentFacetsOfType).concat(action.facet)
                    )
               }
           };
       }

        case SearchEvents.ClearSearchResult: {
            return {
                ...state,
                isSearching: false,
                result: null,
                activeFacets: {
                    createdYears: new Set<string>(),
                    presenters: new Set<string>(),
                    tags: new Set<string>()
               }
           };
       }

        default:
            return state;
   }
}
